import React from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';

export function withRouter(Component) {
    return function Wrapper(props) {
        const history = useHistory();
        const location = useLocation();
        const params = useParams();

        return (
            <Component
                {...props}
                history={history}
                location={location}
                params={params}
            />
        );
    };
}
